import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BallotService } from "./ballot.service";
import { BallotComponent } from "./ballot.component";
import { BallotListService } from "../ballot-list/ballot-list.service";
import {ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";
import { HeaderModule } from '../header/header.module';
import { SessionTimeoutModalModule } from '../session-timeout-modal/session-timeout-modal.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BallotListComponent } from '../ballot-list/ballot-list.component';
import { RemovePipePipe } from '../remove-pipe.pipe';
import { BallotConfirmAmComponent } from './ballot-confirm-am.component';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { BallotErrorModalModule } from "./ballot-error-modal.module";
import {ProgressBarModule} from '../progress-bar/progress-bar.module';
import { DeclineAmDialogComponent } from './decline-am-dialog.component';
import { ChoiceModule } from "../choice/choice.module";
import { RankedChoiceComponent } from "../choice/ranked-choice/ranked-choice.component";
import { UnrankedChoiceComponent } from "../choice/unranked-choice/unranked-choice.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatBadgeModule} from '@angular/material/badge';
import { DashboardComponent } from "../dashboard/dashboard.component";
import { BackButtonConfirmationModalModule } from "../back-button-confirmation-modal/back-button-confirmation-modal.module";

@NgModule({
  declarations: [
    BallotComponent,
    BallotListComponent,
    RemovePipePipe,
    BallotConfirmAmComponent,
    DeclineAmDialogComponent,
  ],
  providers: [
    BallotService,
    BallotListService,
  ],
  imports: [
    BallotErrorModalModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HeaderModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    SessionTimeoutModalModule,
    MatProgressSpinnerModule,
    ProgressBarModule,
    ChoiceModule,
    RankedChoiceComponent,
    UnrankedChoiceComponent,
    MatTooltipModule,
    MatBadgeModule,
    DashboardComponent,
    BackButtonConfirmationModalModule
],
})
export class BallotModule {}
